import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../utilities/onDocumentReady';

// onDocumentReady(() => {
    const $slider = new Swiper('.catalog-detail-gallery-thumbnails .swiper-container', {
        direction: 'vertical',
        slidesPerView: 3,
//        loop: $('.catalog-detail-gallery-thumbnails .swiper-slide').length > 3,
        watchOverflow: true,
        navigation: {
            nextEl: '.catalog-detail-gallery-thumbnails__next',
            prevEl: '.catalog-detail-gallery-thumbnails__prev'
        },
        breakpoints: {
            1919: {
                direction: 'horizontal',
            }
        },
    });

    $slider.on('slideChange', function () {
        $('.catalog-detail-gallery-thumbnails__next').css('background-image','url("../../local/templates/artlife/assets/img/catalog/slider-arrow.png")');
        $('.catalog-detail-gallery-thumbnails__prev').css('background-image','url("../../local/templates/artlife/assets/img/catalog/slider-arrow.png")');
        if ($slider.isEnd) {
            $('.catalog-detail-gallery-thumbnails__next').css('background-image','url("../../local/templates/artlife/assets/img/catalog/slider-arrow-disabled.png")');
            return;
        }
        if ($slider.isBeginning) {
            $('.catalog-detail-gallery-thumbnails__prev').css('background-image','url("../../local/templates/artlife/assets/img/catalog/slider-arrow-disabled.png")');
            return;
        }
    });

    new Swiper('.catalog-detail-gallery-mobile .swiper-container', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.catalog-detail-gallery-mobile__pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
            },
        },
    });

    $('body').on('click', '.catalog-detail-gallery__thumbnail', function () {
        const imgSrc = $(this).attr('data-src');
        $('.catalog-detail-gallery__image')
            .attr('data-src', imgSrc)
            .css('background-image', `url(${imgSrc})`);
    });
// });
